// Literal, case-insensitive prefix match: the same rule as the grouped
// canned-response search, which escapes LIKE wildcards.
export const cannedResponseMatches = (shortCode, term = '') => {
  const query = (term || '').toLowerCase();
  if (!query) return true;
  return (shortCode || '').toLowerCase().startsWith(query);
};

// A previous prefix search is a superset of the current term, so it can be
// filtered locally. An unrelated term must not reuse those rows.
export const cannedQueryCovers = (fetchedQuery, term = '') => {
  if (fetchedQuery == null) return false;
  return (term || '').toLowerCase().startsWith(fetchedQuery.toLowerCase());
};
